

var angular = require('angular');
var ApplicantAPI = require('../api').Applicant;

module.exports = ApplicantUserInvitationController

function ApplicantUserInvitationController($scope, $state, $location){
  var vm = this;
  vm.hasInvite = false;
  vm.invite = {};
  vm.inviteId = $location.search().id;
  var init = function() {
    ApplicantAPI.GetInvitationDetails(vm.inviteId).then(function(result){
      if(result){
        vm.hasInvite = true;
        vm.invite = result;
      }
    });
  }


  vm.joinOrganisation = function(){
    ApplicantAPI.AddInvitedApplicantUser(vm.invite.applicantId, vm.invite.id).then(function(){
      //go somewhere ... applicant dashboard?
      window.location = "/applicant/dashboard";
    })
    .catch(function(resp){
      $scope.error = resp.body.error;
    });
  }


  init();
}
